import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { html, nothing } from "lit";
import { state, query } from "lit/decorators.js";
import { prop } from "../../../decorators/prop/index.js";
import { getPaginationItemClasses, getTitleClasses, getSelectedIndicatorClasses, getBaseIndicatorClasses, getTabClasses } from "./utils.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfTab = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this._placement = "horizontal";
    this._selected = false;
  }
  setSelected(value) {
    this._selected = value;
  }
  setPlacement(value) {
    this._placement = value;
  }
  focus() {
    this.tabElement.focus();
    super.focus();
  }
  render() {
    const paginationItemClass = getPaginationItemClasses(this._placement);
    const titleClass = getTitleClasses(this._selected, this._placement);
    const indicatorClasses = this._selected ? getSelectedIndicatorClasses(this._placement) : getBaseIndicatorClasses(this._placement);
    return html`
      <div id="tabContainer" class="${getTabClasses()}" tabindex="0" role="tab" data-skeleton>
        <div class="${paginationItemClass}">
          <div class="${titleClass}">${this.dsf_title}</div>
          ${this.dsf_subtitle ? html`<div class="dsf-text-s">${this.dsf_subtitle}</div>` : nothing}
        </div>
        <div class="${indicatorClasses}"></div>
      </div>
    `;
  }
};
__decorateClass([
  prop({ type: String })
], DsfTab.prototype, "value", 2);
__decorateClass([
  prop({ type: String })
], DsfTab.prototype, "dsf_title", 2);
__decorateClass([
  prop({ type: String })
], DsfTab.prototype, "dsf_subtitle", 2);
__decorateClass([
  state()
], DsfTab.prototype, "_placement", 2);
__decorateClass([
  state()
], DsfTab.prototype, "_selected", 2);
__decorateClass([
  query("#tabContainer")
], DsfTab.prototype, "tabElement", 2);
DsfTab = __decorateClass([
  defineElement("dsf-tab")
], DsfTab);
export {
  DsfTab
};
